import { useReports } from "@inrange/building-manager-api-client";
import { sortBy } from "@inrange/utils/utils.ts";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import CollapsibleCard from "../site/CollapsibleCard";

const DailyReportsCard = () => {
  const [autorefetch, setAutorefetch] = useState(false);
  const [lastSeenSuccessStartTimes, setLastSeenSuccessStartTimes] =
    useState("");
  const { fetchReports, invokeReports } = useReports(
    autorefetch ? 60_000 : false
  );

  const succeededStartTimes = (fetchReports.data?.executions || [])
    .filter((execution: { status: string }) => execution.status === "SUCCEEDED")
    .map((execution: { startDate: string }) => execution.startDate)
    .join(",");
  const runningCount = (fetchReports.data?.executions || []).filter(
    (execution: { status: string }) => execution.status === "RUNNING"
  ).length;

  useEffect(() => {
    if (
      runningCount === 0 &&
      succeededStartTimes &&
      succeededStartTimes !== lastSeenSuccessStartTimes &&
      autorefetch
    ) {
      setLastSeenSuccessStartTimes(succeededStartTimes);
      setAutorefetch(false);
    } else if (runningCount > 0 && !autorefetch) {
      setAutorefetch(true);
    }
  }, [
    succeededStartTimes,
    lastSeenSuccessStartTimes,
    runningCount,
    autorefetch,
  ]);

  return (
    <CollapsibleCard title="Daily Reports" initialOpen={false}>
      <Button
        variant="success"
        size="sm"
        onClick={() => {
          setAutorefetch(true);
          invokeReports.mutate();
        }}
      >
        Generate reports
      </Button>
      {fetchReports.isLoading ? (
        <div className="mt-3" style={{ fontSize: 14 }}>
          Loading...
        </div>
      ) : (
        <div style={{ fontSize: 14 }}>
          <h6 className="fw-bold mt-3 mb-2" style={{ fontSize: 14 }}>
            Report Outputs
          </h6>
          <ul>
            {Object.entries(fetchReports.data?.reports || {})
              .sort(sortBy((a: [string, unknown]) => a[0]))
              .map(([reportName, files], index) => (
                <li key={index}>
                  {reportName}
                  <ul>
                    {(
                      files as { presignedUrl: string; lastModified: string }[]
                    ).map(
                      (
                        file: { presignedUrl: string; lastModified: string },
                        idx: number
                      ) => (
                        <li key={idx}>
                          <a
                            href={file.presignedUrl}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {reportName}
                          </a>{" "}
                          - {file.lastModified.split("+")[0]}
                        </li>
                      )
                    )}
                  </ul>
                </li>
              ))}
          </ul>
          <h6 className="fw-bold mb-2" style={{ fontSize: 14 }}>
            Report Runs
          </h6>
          <ul>
            {(fetchReports.data?.executions || []).map(
              (
                execution: {
                  status: string;
                  startDate: string;
                  stopDate?: string;
                },
                index: number
              ) => (
                <li key={index}>
                  Status: {execution.status} - Started:{" "}
                  {execution.startDate.split(".")[0]} - Stopped:{" "}
                  {(execution.stopDate || "").split(".")[0]}
                </li>
              )
            )}
          </ul>
        </div>
      )}
    </CollapsibleCard>
  );
};

export default DailyReportsCard;
